<template>
  <div class="App" id="app">
    <el-scrollbar style="height:100%;" ref="scrollBarRef">
      <Header v-show="is_show_header_footer" :active="$route.meta.header"></Header>
      <div class="Content__warp" :style="warpStyles">
        <!--<Menu :header="$route.meta.header" :active="$route.meta.menu" :style="{'min-height' : minHeight +'px'}"></Menu>-->
        <Menu v-if="is_show_Menu" :header="$route.meta.header" :active="$route.meta.menu" style="display:none;"></Menu>
        <div class="Content__main" id="container_max" :style="myStyles">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
          <el-backtop target=".el-scrollbar__wrap"></el-backtop>
        </div>
      </div>
      <Footer v-show="is_show_header_footer"></Footer>

      <!--<div class="aa" v-for="item in 100">
          <h1>{{item}}</h1>
      </div>-->
    </el-scrollbar>

  </div>
</template>

<script>
import Header from '@/component/Header'
import Footer from '@/component/Footer'
import Menu from '@/component/Menu'
import {getSession, outLogin} from './util/login'
import {CACHE_KEY} from "./constant";

export default {
  name: 'App',
  components: {Header, Menu, Footer},
  data() {
    return {
      minHeight: 0,
      myStyles: {
        minHeight: '400px',
        width: 'calc(100% - 0px)',
        marginLeft: '75px',
        'min-width': '1000px',
        /*flex: 1;*/
        // height: '100%',
        'margin-left': '75px',
        background: 'white',
        padding: '15px 15px 0 15px',
        'border-radius': '0px',
      },
      warpStyles: {
        marginTop: '68px',
      },
      is_show_Menu: false,
      is_show_header_footer: false,
    }
  },
  // 使用watch 监听$router的变化,
  watch: {
    '$route': function (to, from) {
      //路由跳转时回到顶部
      // document.querySelector("#app").scrollIntoView(true);
      if (to.name != 'login') {
        //路由发生改变时获取最新token
        this.show();
        this.reloadUser();
      }
      this.reload();
    }
  },
  mounted() {
    let that = this;
    this.reload()
    window.onresize = function () {
      that.reloadHeight()
    };
    let count = 0;
    this.timeFun = setInterval(() => {
      count++;
      that.reloadHeight()
      //console.log("加载高度 count="+ count)
    }, 2000);
    //console.log(height, this.minHeight, this.myStyles)

  },
  methods: {
    show() {
      //路由跳转时回到顶部
      // document.querySelector("#container_max").scrollIntoView(true);
      // 回到顶部
      this.$refs.scrollBarRef.wrap.scrollTop = 0;
    },
    reloadUser() {
      let path = window.location.pathname;
      if (path != '/login' & path != '/register' & path != '/forget') {
        let user_info = getSession(CACHE_KEY.USER_INFO);
        let new_time = new Date().getTime();
        if (user_info != null && user_info != undefined) {
          let login_time = user_info.times;
          //已登录时间
          let end_time = new_time - login_time;
          //有效时间
          let day = 1000 * 60 * 60 * 24 * 1
          //console.log(end_time, day);
          if (end_time > day) {
            //登录过期
            sessionStorage.removeItem("is_out_login");
            outLogin()
          }
        } else {
          sessionStorage.removeItem("is_out_login");
          outLogin()
        }
      }
    },
    reloadHeight() {
      let path = window.location.pathname;
      let height2 = document.documentElement.clientHeight;
      if (height2 < 400) {
        height2 = 400
      }
      if (path == '/login') {
        this.warpStyles.marginTop = '0px'
        this.is_show_header_footer = false;
        this.minHeight = height2;
        this.myStyles.minHeight = this.minHeight + 'px';
         this.warpStyles['padding-bottom'] = '0px'
      } else {
        this.warpStyles.marginTop = '68px'
        this.is_show_header_footer = true;
        this.minHeight = height2 - 128;
        this.myStyles.minHeight = this.minHeight + 'px';
        this.warpStyles['padding-bottom'] = '61px'
      }
      this.myStyles.padding = path=='/login'?'0px':'15px';
    },
    reload() {
      let path = window.location.pathname;
      if (path == '/data_index' || path == '/'  || path == '/register' || path == '/about_platform' || path== '/forget') {
        this.myStyles.width = '100%';
        this.myStyles.marginLeft = '0px'
        this.is_show_Menu = false
        this.myStyles['padding-left'] = '15px'
      }else if(path == '/login'){
           this.myStyles['padding-left'] = '0px'
           this.myStyles['padding-bottom'] = '0px'
      }else {
        // this.myStyles.width = 'calc(100% - 75px)';
        // this.myStyles.marginLeft = '75px'
     //    this.myStyles.width = 'calc(100% - 85px)';
        this.myStyles.marginLeft = '85px'
        this.is_show_Menu = true
        this.myStyles['padding-left'] = '15px'
       
      }
      //获取浏览器高度
      this.reloadHeight()
    },
  }
}
</script>
<style scoped lang="scss">

#app {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  //background: #7b9dca;
  background: white !important;
  //background: #5a84bd;
  //background: #4797f0;
  // #5e9cca
}

.Content__warp {
  width: 100%;
  height: calc(100% - 148px);
  display: flex;
  min-width: 1100px;
}
.Content__main{
     margin-left: 0px !important;
}
/deep/ .el-backtop{
     bottom: 65px !important;
}
//.Content__main {
//  min-width: 1000px;
//  /*flex: 1;*/
//  width: calc(100% - 75px);
//  height: 100%;
//  margin-left: 75px;
//  background: white;
//  padding: 15px;
//  border-radius: 0px;
//}
</style>
<style>
/**::-webkit-scrollbar {
    width: 15px;
    height: 15px;
    background-color: #ffffff;
}

!*定义滚动条轨道 内阴影+圆角*!
*::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 15px;
    background-color: #F5F5F5;
}

!*定义滑块 内阴影+圆角*!
*::-webkit-scrollbar-thumb {
    border-radius: 15px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #524f4f;
}*/
.el-scrollbar__wrap {
  overflow: auto !important;
}

.el-scrollbar__bar {
  z-index: 9999;
}

.ApplicationHeader {
  padding-left: 4px !important;
  padding-right: 4px !important;
  font-size: 16px;
  padding-top: 0px !important;
}

.el-table__cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>